<template>
  <div class="no-result">   
    <p class="no-result-text">{{title}}</p>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    props: {
      title: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import "~common/stylus/variable"
  @import "~common/stylus/mixin"

  .no-result
    text-align: center
    /*
    .no-result-icon
      width: 86px
      height: 90px
      margin: 0 auto
      bg-image('no-result')
      background-size: 86px 90px
        */
    .no-result-text
      font-size:20px
      color: $color-text-d
</style>


// WEBPACK FOOTER //
// src/base/no-result/no-result.vue